import React, { PureComponent } from 'react';
import { Modal, Input, Button, message, Spin, Popover } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { CheckboxWithAll } from '../../components';
// import { callApi } from 'utils';
import { callApi } from '../../../../utils/callApi/rest';

import { api } from '../../config';
import { getBasicInfo } from '../../utils';
import { cloneDeep } from 'lodash';
import './index.less';
const allOperationTyps = {
	ALL: 1,
	NOTALL: 0
};
const prefixCls = 'right-management-role';
class RoleManagement extends PureComponent {
	state={
		roleList: [],
		backupRoleList: [],
		readOnly: true,
		currentRole: 0,
		currentRoleName: undefined,
		addModalVisable: false,
		roleName: '',
		loading: true,
		options: [], //处理过的所有权限
	}

	basicInfo = {};
	addModalRef = React.createRef();

	temAssignedOperations=[];
	allPrivilegesLenght = 0;

	componentDidMount() {
		this.init();
	}

	componentDidUpdate(prevProps) {
		if (prevProps.allPrivileges !== this.props.allPrivileges) {
			this.init();
		}
	}

	init= () => {
		this.basicInfo = getBasicInfo();
		this.translateAllPrivileges();
	}

	//转化权限数据格式， 目的是匹配全选组件
	//this.allPrivilegesLenght ：此处顺便计算全部权限的长度， 因为当选择所有的权限时候，不用返回权限id

	translateAllPrivileges = () => {
		const { allPrivileges = [] } = this.props;
		let allPrivilegesLenght = 0;
		const options =	allPrivileges.map((item = {}, index) => {
			const { categoryName, operations = [], categoryId } = item;
			const ids = [];
			allPrivilegesLenght += operations.length;
			const plainOptions = operations.map((el, p) => {
				const optionObj = { label: el.name, value: el.id };
				if (index === 0 && p === 0) {
					optionObj.disabled = true;
				}
				ids.push(el.id);
				return optionObj;
			});
			return { categoryName, categoryId, plainOptions, ids };
		});
		this.allPrivilegesLenght = allPrivilegesLenght;
		this.setState({ options }, () => {
			this.listPrivilegeRole();
		});
	}

	listPrivilegeRole =(needLoading) => {
		const { currentRole } = this.state;
		needLoading && this.setState({ loading: true });
		callApi({
			api: api.listPrivilegeRole,
			data: {
				...this.basicInfo,
				includeOperationFlag: 1
			},
			success: (res = {}) => {
				const roles = this.tranRoles(res.roles);
				this.setState({
					roleList: roles || [],
					backupRoleList: cloneDeep(roles),
					currentRole: currentRole || 0,
					loading: false,
					currentRoleName: roles[currentRole || 0]?.name
				});
			}
		});
	}

	tranRoles = (roles) => {
		const { options } = this.state;
		const rolesNew = roles.map((roleItem) => {
			const { id, name, allOperationFlag, assignedOperations = [] } = roleItem || {};
			let checkLists = [];
			if (allOperationFlag === allOperationTyps.ALL) {
				 checkLists = options.map((option) => [...option.ids]);
			} else {
				 checkLists = options.map((option) => {
					 let assignedIds = [];
					assignedOperations.some((el) => {
						if (el.categoryId === option.categoryId) {
							const checkedListOld = el?.operations || [];
							assignedIds = checkedListOld.map(p => p.id);
							return true;
						}
						return false;
					});

					return assignedIds;
				 });
			}
			return { checkedList: checkLists, name, id };
		});
		return rolesNew;
	}

	addPrivilegeRole = () => {
		const { roleName, options = [], roleList } = this.state;
		const defaulId = options[0]?.plainOptions[0]?.value;
		const roleListNew = [...roleList];
		const data = {
			name: roleName,
			allOperationFlag: 0,
		};
		if (defaulId) {
			data.checkedList = [[defaulId]];
		}
		roleListNew.push(data);
		this.setState({ currentRoleName: roleName, roleList: roleListNew, addModalVisable: false, currentRole: roleListNew.length - 1, readOnly: false });
	}

	changeTarget = (i) => {
		const { roleList = [], readOnly } = this.state;
		if (!readOnly) {
      	return false;
		}
		const currentRoleName = roleList[i].name;
		this.setState({ currentRole: i, currentRoleName });
	}

	deletePrivilegeRole = () => {
		let { roleList = [], currentRole } = this.state;
		callApi({
			api: api.deletePrivilegeRole,
			data: {
			  ...this.basicInfo,
				id: roleList[currentRole]?.id,
			},
			success: (res) => {
				const roleListNew = [...roleList];
				roleListNew.splice(currentRole, 1);
				const backupRoleList = cloneDeep(roleListNew);
				currentRole = currentRole - 1;
				if (roleListNew.length === currentRole) {
					currentRole = 0; //如果是删的是最后一个，则显示第一个，否则显示下一个
				}
				this.setState({ roleList: roleListNew, backupRoleList, currentRole, currentRoleName: roleList[currentRole]?.name });
			}
		});
	}

	deleteItem = () => {
		Modal.confirm({
			title: '确定要删除角色？',
			icon: <ExclamationCircleOutlined />,
			content: '删除权限将影响已选择该角色成员的功能权限',
			okText: '确认',
			cancelText: '取消',
			onOk: this.deletePrivilegeRole
		});
	}

	//此处顺便计算全部权限的长度， 因为当选择所有的权限时候，不用返回权限id

	savePrivilegeRole = () => {
		const { roleList = [], currentRole, currentRoleName } = this.state;
		const { id, checkedList } = roleList[currentRole] || {};
		let apiUrl = api.createPrivilegeRole;
		if (!currentRoleName) {
			return false;
		}
		const data = {
	    ...this.basicInfo,
			name: currentRoleName,
			allOperationFlag: 1,
		};
		let assignedOperationsL = 0;
	  const assignedOperationIds = checkedList.reduce((prev, item = []) => {
			assignedOperationsL += item.length;
			return [...prev, ...item];
		}, []);
	   if (assignedOperationsL < this.allPrivilegesLenght) {
			data.allOperationFlag = 0;
			data.assignedOperationIds = assignedOperationIds;
		 }
		 if (id) {
			data.id = id;
			apiUrl = api.updatePrivilegeRole;
		 }
		callApi({
			api: apiUrl,
			data: data,
			success: (res) => {
				this.listPrivilegeRole();
				message.success('保存成功');
				this.setState({ readOnly: true });
			}
		});
	}

	cancelUpdate = () => {
		let { roleList = [], backupRoleList = [], currentRole } = this.state;
		const backupRoleListNew = cloneDeep(backupRoleList);
		const { id } = roleList[currentRole] || {};
		if (!id) {
			currentRole = 0;
		}
		this.setState({
			roleList: backupRoleListNew,
			readOnly: true,
			currentRole,
			currentRoleName: backupRoleListNew[currentRole]?.name
		});
	}

	closeAddModal = (e) => {
		this.setState({ addModalVisable: false });
	}

	addRole = (e) => {
		const { readOnly } = this.state;
		if (!readOnly) {
			message.warn('请保存角色配置');
      	return false;
		}
		e.stopPropagation();
		this.setState({ roleName: '', addModalVisable: true });
	}

	updateCurrentPrivilegelist = (values, index) => {
		const { roleList, currentRole, options = [] } = this.state;
		const roleListNew = cloneDeep(roleList);
		//因为需要默认第一个权限被勾选，所以当用户点击全选框取消全选时，默认加上第一项的id
		if (index === 0 && values.length < 1) {
			const defaulId = options[0]?.plainOptions[0]?.value;
			values = [defaulId];
		}
		roleListNew[currentRole].checkedList[index] = values;

		this.setState({ roleList: roleListNew });
	}

	updateName = (name) => {
		this.setState({ currentRoleName: name });
	}

	render() {
		const { currentRoleName, roleList, readOnly, currentRole, addModalVisable, roleName, loading, options } = this.state;
		const { onChange } = this.props;
		const { checkedList = [] } = roleList[currentRole] || {};
		const addModal = (
			<div className={prefixCls + '-addModal'} onClick={(e) => { e.stopPropagation(); }}>
				<div className={prefixCls + '-addModal-header'}><span className='addLable'>新增角色</span><span className='closeIcon'
					onClick={this.closeAddModal}>x</span></div>
				<Input className={prefixCls + '-addModal-input'} value={roleName} maxLength={8}
					onChange={(e) => { this.setState({ roleName: e.target.value }); }}/>
				<Button disabled={!roleName} type='primary' onClick={this.addPrivilegeRole} >确定</Button>
			</div>
		);
		//当滚动条滚动时，关掉添加角色modal
		this.mune && this.mune.addEventListener('scroll', this.closeAddModal);
		return (
			<div className={prefixCls} onClick={this.closeAddModal}>
				<Modal
					visible={ true }
					title='角色管理'
					width={612}
					footer={null}
					bodyStyle={{ height: '476px' }}
					onCancel = {() => { this.setState({ addModalVisable: false }, () => { onChange && onChange(); }); }} >
					{
						loading ? <Spin spinning={loading} style={{ height: '100%', width: '100%' }} />
							:	<div className={`${prefixCls}-content`}>
								<div className={`${prefixCls}-content-left`} ref={(e) => { this.mune = e; }}>
									{
										roleList.map((item, index) => {
											return <div
												key={ index + 'role'}
												className={index === currentRole ? `${prefixCls}-content-left-roleItem selected` : `${prefixCls}-content-left-roleItem`}
												onClick={() => { this.changeTarget(index); }}>{item.name}</div>;
										})
									}
									{/* <div className='addRoleButton' ref={(e) => { this.AddRef = e; }}> */}
									<Popover visible={addModalVisable} overlayClassName={`${prefixCls}-popup`} placement="bottomLeft" content={addModal} trigger='click'>
										<div className={`${prefixCls}-content-left-roleItem addRoleButton`} onClick={this.addRole}>
										+ 新增
										</div>
									</Popover>

										 {/* <Modal visible={addModalVisable} getContainer={false}>ee</Modal> */}
										 {/* {
											addModalVisable && <div className='addModal' ref={this.addModalRef} onClick={(e) => { e.stopPropagation(); }}>
												<div className='addModal-header'><span className='addLable'>新增角色</span><span className='closeIcon'
													onClick={this.closeAddModal}>x</span></div>
												<Input className='addModal-input' value={roleName} maxLength={8}
													onChange={(e) => { this.setState({ roleName: e.target.value }); }}/>
												<Button disabled={!roleName} type='primary' onClick={this.addPrivilegeRole} >确定</Button>
											</div>
										} */}
									</div>

								{/* </div> */}
								{
									roleList.length > 0 ? 	<div className={`${prefixCls}-content-right`}>
										<div className={`${prefixCls}-content-right-header`}>
											{
												readOnly ? <span>{currentRoleName} </span>
													: <div><Input
														className={!currentRoleName && 'error'}
														maxLength={8} value={currentRoleName}
														onChange={(e) => { this.setState({ currentRoleName: e.target.value }); }} />
													{!currentRoleName && <span className='error'>请填写</span>}</div>
											}
											{
												readOnly ? <div > <Button className={prefixCls + '-button'} danger onClick={this.deleteItem}>删除</Button>
													<Button onClick={() => { this.setState({ readOnly: false }); }}>编辑</Button></div>
													: <div> <Button className={prefixCls + '-button'} onClick={this.cancelUpdate}>取消</Button>
														<Button type="primary" onClick={this.savePrivilegeRole}>保存</Button>
													</div>
											}
										</div>
										<div className={`${prefixCls}-content-right-content`}>
											{
												options.map((item = {}, index) => {
													return < CheckboxWithAll
														key={item.categoryId}
														options={item.plainOptions || []}
														readOnly={readOnly}
														checkAllLabel={item.categoryName}
														value={checkedList[index]}
														onChange={(checkedList) => { this.updateCurrentPrivilegelist(checkedList, index); }}
													/>;
												})
											}
										</div>
									</div> : <div className={`${prefixCls}-content-right-empty`}>请从左侧添加角色</div>
								}
							</div>
					}
				</Modal>
			</div>
		);
	}
}

export default RoleManagement;
